module.exports = __webpack_public_path__ + "assets/montsacopa-min.b79152e47c63948865d847ef9f8f66ab.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/MasCorominola/montsacopa-min.jpg
 ** module id = 428
 ** module chunks = 0
 **/